
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.04 12.999C26.04 20.179 20.21 26 13.02 26 5.83 26 0 20.179 0 12.999S5.83 0 13.02 0a12.97 12.97 0 0110.593 5.452 12.897 12.897 0 012.426 7.547z","fill":"#FFA400"}}),_c('path',{attrs:{"d":"M25.765 2.405l-2.144 3.049s-.005 0-.005-.005a12.891 12.891 0 00-2.093-2.295L23.277.661a1.52 1.52 0 012.488 1.744z","fill":"#FFA400"}}),_c('path',{attrs:{"d":"M23.619 5.456l-8.608 12.23-1.013 1.443a1.184 1.184 0 01-1.806.156l-5.894-5.883a1.517 1.517 0 010-2.148l.059-.061a1.523 1.523 0 012.15 0l3.929 3.921a.472.472 0 00.722-.063L21.52 3.156a12.89 12.89 0 012.093 2.295c0 .003.002.003.005.005z","fill":"#fff"}})])
          )
        }
      }
    